
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import ApiClient from "@/utilities/ApiClient";
    import Utils from "@/utilities/Utils";
    import ApiButton from "@/vue/components/ApiButton.vue";
    import PrimaryButton from "@/vue/components/PrimaryButton.vue";
    import ConfirmDialogue from "@/vue/components/ConfirmDialogue.vue";
    import DatePicker from "@/vue/components/DatePicker.vue";
    import TextPart from "@/vue/components/PageParts/TextPart.vue";
    import NotePart from "@/vue/components/PageParts/NotePart.vue";
    import MapPartLeaflet from "@/vue/components/PageParts/MapPartLeaflet.vue";
    import MapPartGoogle from "@/vue/components/PageParts/MapPartGoogle.vue";
    import ResourceAndTextPart from "@/vue/components/PageParts/ResourceAndTextPart.vue";
    import RadioChoicePart from "@/vue/components/PageParts/RadioChoicePart.vue";
    import CheckboxChoicesPart from "@/vue/components/PageParts/CheckboxChoicesPart.vue";
    import FreeTextPart from "@/vue/components/PageParts/FreeTextPart.vue";
    import DownloadPart from "@/vue/components/PageParts/DownloadPart.vue";
    import NumericId from "@/vue/components/NumericId.vue";
    import { previewVisitID, allPagesID } from "@/model/Enums";
    import { IBriefingResponse } from "@/model/IBriefingResponse";
    import { Site } from "@/model/Site";
    import { Pathway } from "@/model/Pathway";
    import { Visit } from "@/model/Visit";
    import { IPage, Page } from "@/model/Page";
    import { VisitAnswer } from "@/model/VisitAnswer";

    @Component({ components: {
            ApiButton,
            PrimaryButton,
            ConfirmDialogue,
            DatePicker,
            TextPart,
            NotePart,
            MapPartLeaflet,
            MapPartGoogle,
            ResourceAndTextPart,
            RadioChoicePart,
            CheckboxChoicesPart,
            FreeTextPart,
            DownloadPart,
            NumericId
        }})
    export default class BriefingPrint extends Vue {

        async mounted(): Promise<void> {
            // this.hideTest = this.$route.params.hideTest === ...;
            this.visitID = this.$route.params.visitID ?? Utils.emptyGuidValue;
            this.previewPathwayID = Utils.getUrlQueryValue(this.$route, "previewPathwayID");
            this.pageID = this.$route.params.pageID ?? Utils.emptyGuidValue;
            this.load();
        }

        //
        // -- properties
        //

        hideTest: boolean = false
        visitID: string = "";
        pageID: string = "";
        previewPathwayID: string = "";

        site: Site = new Site();
        pathway: Pathway = new Pathway();
        visit: Visit = new Visit();
        pages: Array<Page> = [];

        get isPreviewMode(): boolean {
            return !Utils.isEmptyId(this.previewPathwayID) && this.visitID === previewVisitID;
        }

        async load(): Promise<void> {
            //const pageID = Utils.isEmptyId(this.pageID) ? firstPageID : this.pageID;
            const path = this.isPreviewMode
                ? `/api/page/briefing?visitID=${this.visitID}&pageID=${allPagesID}&previewPathwayID=${this.previewPathwayID}`
                : `/api/page/briefing?visitID=${this.visitID}&pageID=${allPagesID}`;
            const data: IBriefingResponse = await ApiClient.get(path);

console.log("⚡ data = ", data);

            //this.hasLinkExpired = data.hasExpired;

            window.document.title = `${data.site.name} | ${data.pathway.description}`;

            // create any empty answers array so we don't have to add them later (and so reactivity works?)
            for(const page of data.pages) {
                for(const part of page.parts) {
                    if (!data.visit.answers.some(a => a.pagePartID === part.id)) {
                        data.visit.answers.push(VisitAnswer.create(this.visitID, part.id));
                    }
                }
            }

            this.site.update(data.site);
            this.pathway.update(data.pathway);
            this.pages = data.pages
                .filter((p: IPage) => (!p.isQuiz || !this.hideTest) && p.parts.length > 0)
                .map((p: IPage) => new Page(p));
            this.visit.update(data.visit);

            //await Store.dispatch("setSite", this.site);

            // Vue.nextTick(() => {
            //     // hacky delay to make sure page has properly loaded...
            //     setTimeout(() => { window.print(); }, 300);
            // });
        }

        answerForPart(pagePartID: string): VisitAnswer {
            return this.visit.answers.find(r => r.pagePartID === pagePartID) ?? new VisitAnswer(VisitAnswer.create(this.visitID, pagePartID));
        }
    }
